import { TimeRange } from "../app/model/opening-hours";

export class TimeSlotIdGenerator {
  private static timeSlotsCounter = 0;

  static generate(): string {
    return '' + TimeSlotIdGenerator.timeSlotsCounter++;
  }
}

export class TimeSlotsValidator {
  static hasOverlappingTimeSlots(timeSlots: TimeRange[]) {
    // Convert times to an array of objects with start and end in minutes
    const intervals = timeSlots.map((slot) => ({
      from: TimeSlotsValidator.toMinutes(`${slot.from.hours}:${slot.from.minutes}`),
      to: TimeSlotsValidator.toMinutes(`${slot.to.hours}:${slot.to.minutes}`),
    }));

    // Sort intervals by start time
    intervals.sort((a, b) => a.from - b.from);

    // Check for overlaps
    for (let i = 0; i < intervals.length - 1; i++) {
      if (intervals[i].to > intervals[i + 1].from) {
        return true; // Overlap found
      }
    }

    return false; // No overlaps
  }

  static areStartTimesBeforeEndTimes(timeSlots: TimeRange[]) {
    return timeSlots.every(TimeSlotsValidator.isStartTimeBeforeEndTime);
  }

  private static isStartTimeBeforeEndTime(timeSlot: TimeRange) {
    const startTimeMinutes = TimeSlotsValidator.toMinutes(
      `${timeSlot.from.hours}:${timeSlot.from.minutes}`
    );
    const endTimeMinutes = TimeSlotsValidator.toMinutes(
      `${timeSlot.to.hours}:${timeSlot.to.minutes}`
    );

    return startTimeMinutes <= endTimeMinutes;
  }

  // Convert HH:MM to total minutes since midnight
  private static toMinutes(time: string) {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }
}

